module.exports = __webpack_public_path__ + "static/media/nave-logo-white.b83f3160.svg";